export enum UdfEntityType {
  EMPLOYEE = "EMPLOYEE",
  GRANT = "GRANT",
}

export enum UdfDataType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  DATE = "DATE",
  DROPDOWN = "DROPDOWN",
}

export interface UdfValidations {
  min?: number;
  max?: number;
  dateMin?: string;
  dateMax?: string;
}

export interface CustomField {
  id: string;
  companyId: string;
  name: string;
  fieldPath: string;
  entityType: UdfEntityType;
  dataType: UdfDataType;
  placeholder?: string;
  description?: string;
  isRequired: boolean;
  validations?: UdfValidations;
  displayOrder: number;
  valueSet?: string[];
  status: "ACTIVE" | "INACTIVE";
  createdAt: string;
  updatedAt: string;
}

export interface CreateCustomFieldDto {
  name: string;
  fieldPath?: string;
  entityType: UdfEntityType;
  dataType: UdfDataType;
  placeholder?: string;
  description?: string;
  isRequired?: boolean;
  validations?: UdfValidations;
  displayOrder?: number;
  valueSet?: string[];
}

export interface UpdateCustomFieldDto {
  name?: string;
  dataType?: UdfDataType;
  placeholder?: string;
  description?: string;
  isRequired?: boolean;
  validations?: UdfValidations;
  displayOrder?: number;
  valueSet?: string[];
}

export type CustomFieldValues = Record<
  string,
  string | number | boolean | null
>;
